exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-4317c033]{cursor:pointer}.quote[data-v-4317c033]{display:block;margin-left:auto;margin-right:auto}.quote-holder[data-v-4317c033]{background:#fff;margin-bottom:3px;position:relative;overflow:hidden;padding:10px;min-height:20px}.quote_btn[data-v-4317c033]{border-radius:0;width:100%;display:block;cursor:pointer}.quote_control[data-v-4317c033]{width:100%;display:flex;padding:15px 5px 5px;background:#fff}.control_1[data-v-4317c033]{flex:2}.control_2[data-v-4317c033]{flex:1;justify-content:flex-end;align-items:center;font-size:20px;font-weight:700;color:#51d2b7}#form__group[data-v-4317c033]{box-sizing:border-box;overflow:hidden}textarea[data-v-4317c033]{margin:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4317c033","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/number.vue
// module id = 392
// module chunks = 0